import { isSet } from "./isSet";
import { getFullScope } from "./getFullScope";
import { inferType } from "./inferType";
export function lookup(i18n, scope) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = Object.assign({}, options);
  var locale = "locale" in options ? options.locale : i18n.locale;
  var localeType = inferType(locale);
  var locales = i18n.locales.get(localeType === "string" ? locale : typeof locale).slice();
  var keys = getFullScope(i18n, scope, options).split(i18n.defaultSeparator).map(function (component) {
    return i18n.transformKey(component);
  });
  var entries = locales.map(function (locale) {
    return keys.reduce(function (path, key) {
      return path && path[key];
    }, i18n.translations[locale]);
  });
  entries.push(options.defaultValue);
  return entries.find(function (entry) {
    return isSet(entry);
  });
}